var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "topbar"
  }, [_c('div', {
    staticClass: "w1200 bc",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('ul', {
    staticClass: "topbar-right fr"
  }, [(_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.loginUrl
    }
  }, [_vm._v("[登录]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == false) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.registerUrl
    }
  }, [_vm._v("[注册]")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('span', [_vm._v("您好")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    attrs: {
      "href": _vm.userCenterUrl
    }
  }, [_vm._v(_vm._s(_vm.account))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin == true) ? _c('li', [_c('a', {
    staticClass: "co2",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("[退出]")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.aboutUsUrl
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.contactUrl,
      "target": "_blank"
    }
  }, [_vm._v("联系客服")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "mouseenter": function($event) {
        _vm.mobileAppShow()
      },
      "mouseleave": function($event) {
        _vm.mobileAppHidden()
      }
    }
  }, [_vm._v("手机商城")]), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "demensional_code"
  }, [_c('img', {
    attrs: {
      "width": "100px",
      "src": require("../../../static/images/dimensional_code.png")
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "topbar-left fl"
  }, [_c('li', [_vm._v("\n\t\t\t\t\t\t您好！欢迎来到相伴宝！\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "co1",
    attrs: {
      "href": _vm.indexUrl
    }
  }, [_vm._v("返回相伴宝")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header line"
  }, [_c('div', {
    staticClass: "w1200 bc",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('a', {
    staticClass: "logo fl",
    attrs: {
      "href": _vm.indexUrl,
      "title": "云永云商城"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('span', {
    staticClass: "ico"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortParam),
      expression: "sortParam"
    }],
    staticClass: "text",
    attrs: {
      "type": "text",
      "placeholder": "请输入关键字"
    },
    domProps: {
      "value": (_vm.sortParam)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sortParam = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.findGoods()
      }
    }
  }, [_vm._v("搜商品")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-left": "3px"
    },
    on: {
      "click": function($event) {
        _vm.findShops()
      }
    }
  }, [_vm._v("搜店铺")])]), _vm._v(" "), _c('div', {
    staticClass: "r-box fr",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "mycart",
    on: {
      "mouseenter": function($event) {
        _vm.shopCarShow()
      },
      "mouseleave": function($event) {
        _vm.shopCarHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-cart"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("我的购物车")]), _vm._v(" "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.shoppingCartNum))]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-list none",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), (_vm.shoppingCartNum == 0) ? _c('div', {
    staticClass: "no-goods"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/settleup-nogoods.png"),
      "width": "57",
      "height": "49"
    }
  }), _vm._v("购物车中还没有商品，赶紧选购吧！\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.shoppingCartNum > 0) ? _c('div', {
    staticClass: "mylist"
  }, [_c('h4', [_vm._v("最新加入的商品")]), _vm._v(" "), _c('ul', _vm._l((_vm.boList), function(bo) {
    return _c('li', {
      staticClass: "li-2",
      attrs: {
        "id": bo.goodsCode + '_cart_pro'
      }
    }, [_c('a', {
      staticClass: "fl spic",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": bo.imgSmall,
        "width": "50",
        "height": "50"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "name"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(bo.goodsName))]), _vm._v("    "), _c('span', [_vm._v("数量：" + _vm._s(bo.goodsNumber))])]), _vm._v(" "), _c('p', {
      staticClass: "other"
    }, [_c('span', [_vm._v("￥" + _vm._s(bo.goodsPrice))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.deleteGoods(bo.goodsCode)
        }
      }
    }, [_vm._v("删除")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "fbar"
  }, [_c('span', {
    staticClass: "fl ml10"
  }, [_vm._v("共" + _vm._s(_vm.count) + "件商品　共计"), _c('b', [_vm._v("￥ " + _vm._s(_vm.sumMoney))])]), _vm._v(" "), _c('a', {
    staticClass: "fr gobuy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("去购物车")])])]) : _vm._e()])]), _vm._v(" "), (_vm.isLogin == true) ? _c('div', {
    staticClass: "myorder ml25",
    on: {
      "mouseenter": function($event) {
        _vm.orderShow()
      },
      "mouseleave": function($event) {
        _vm.orderHide()
      }
    }
  }, [_c('i', {
    staticClass: "ico-orders"
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.goOrder('')
      }
    }
  }, [_vm._v("我的订单 "), _c('span', {
    staticClass: "ico-shopping-amount"
  }, [_vm._v(_vm._s(_vm.allCount))])]), _vm._v(" "), _c('i', {
    staticClass: "ico-r"
  }), _vm._v(" "), _c('div', {
    staticClass: "orders-list orders"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_pay')
      }
    }
  }, [_vm._v("等待买家付款 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.payCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_send_goods')
      }
    }
  }, [_vm._v("等待卖家发货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.sendCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('wait_buyer_confirm_goods')
      }
    }
  }, [_vm._v("等待确认收货 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.putCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_finish')
      }
    }
  }, [_vm._v("订单完成 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.receiveCount))])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.goOrder('trade_close')
      }
    }
  }, [_vm._v("订单关闭 "), _c('span', {
    staticClass: "ico-shopping-amount",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.closeCount))])])])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "focus_nav",
    staticStyle: {
      "background": "#2C3847"
    },
    on: {
      "mouseover": function($event) {
        _vm.hoverShow()
      },
      "mouseout": function($event) {
        _vm.hoverHide()
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "navTime"
    }
  }, [_c('div', {
    staticClass: "navTime"
  }, [_c('ul', [_c('li', {
    class: {
      cur: _vm.seckillCode == _vm.secKillBo.activityCode
    },
    on: {
      "click": function($event) {
        _vm.chooseActivity(_vm.secKillBo.activityCode, _vm.secKillBo.activityBeginTime, _vm.secKillBo.activityEndTime)
      }
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v(_vm._s(_vm.secKillBo.activityBeginTime))]), _vm._v(" "), _c('p', {
    staticClass: "nav_kq"
  }, [_vm._v("已开抢")])]), _vm._v(" "), _vm._l((_vm.secKillList), function(seckill, index) {
    return _c('li', {
      key: seckill.id,
      class: {
        cur: _vm.seckillCode == seckill.activityCode
      },
      on: {
        "click": function($event) {
          _vm.chooseActivity(seckill.activityCode, seckill.activityBeginTime, seckill.activityEndTime)
        }
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "17px"
      }
    }, [_vm._v(_vm._s(seckill.activityBeginTime))]), _vm._v(" "), _c('p', {
      staticClass: "nav_kq"
    }, [_vm._v("即将开场")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "btn_nav"
  }, [_c('a', {
    staticClass: "change-bnt prev-bnt",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.prev_move()
      }
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('a', {
    staticClass: "change-bnt next-bnt",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.next_move()
      }
    }
  }, [_vm._v(">")])])])]), _vm._v(" "), _c('div', {
    staticClass: "shopWarp"
  }, [_c('div', {
    staticClass: "shopBox"
  }, [_c('ul', _vm._l((_vm.goodsList), function(good) {
    return _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(good.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": good.imgMiddle,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('p', {
      staticClass: "rightTitle"
    }, [_vm._v(_vm._s(good.goodsName))]), _vm._v(" "), _c('p', {
      staticClass: "rightdetail"
    }, [_vm._v(_vm._s(good.goodsNameDesc))]), _vm._v(" "), _c('div', {
      staticClass: "priceleft"
    }, [_c('span', {
      staticClass: "originalPrice1"
    }, [_vm._v("￥" + _vm._s((good.unitPrice / 100).toFixed(2)))]), _vm._v(" "), _c('br'), _vm._v(" "), (good.seckillPrice.length < 6) ? _c('span', {
      staticClass: "currentPrice1"
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "500"
      }
    }, [_vm._v("￥")]), _vm._v(_vm._s((good.seckillPrice / 100).toFixed(2)))]) : _c('span', {
      staticClass: "currentPrice1"
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "500"
      }
    }, [_vm._v("￥")]), _vm._v(_vm._s((good.seckillPrice / 100).toFixed(0)))])]), _vm._v(" "), (_vm.compareActTime(_vm.activityBeginTime, _vm.activityEndTime)) ? _c('div', {
      staticClass: "priceright link-btn"
    }, [_vm._v("\n                            \t\t马上抢\n                        ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }), _vm._v(" "), (_vm.compareActTime(_vm.activityBeginTime, _vm.activityEndTime)) ? _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "num"
    }, [_c('span', [_vm._v("已抢购" + _vm._s((good.saleNumberTotal + good.inpSaleNumber + good.goodsNumber) == 0 ? 0 : (((good.saleNumberTotal + good.inpSaleNumber) / (good.saleNumberTotal + good.inpSaleNumber + good.goodsNumber) * 100).toFixed(0))) + "%")]), _vm._v(" "), _c('span', [_vm._v("已抢购" + _vm._s(good.saleNumberTotal + good.inpSaleNumber) + "件")])]), _vm._v(" "), _c('div', {
      staticClass: "down"
    }, [_c('div', {
      style: ({
        'width': (good.saleNumberTotal + good.inpSaleNumber + good.goodsNumber) == 0 ? '0%' : (((good.saleNumberTotal + good.inpSaleNumber) / (good.saleNumberTotal + good.inpSaleNumber + good.goodsNumber) * 100).toFixed(0) + '%')
      })
    })])]) : _vm._e()])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', [_c('h2', {
    staticClass: "head_logo left"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "src": require("../../../static/images/head_logo.png"),
      "width": "95px",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "headRight headLeft left"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])])]), _vm._v(" "), _c('div', {
    staticClass: "headRight right"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../../../static/images/smallLogo.png"),
      "alt": ""
    }
  }), _vm._v("\n                        \t限时限量抢\n                    ")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../static/images/smallLogo1.png"),
      "alt": ""
    }
  }), _vm._v("\n                        30天低价\n                    ")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../../../static/images/smallLogo2.png"),
      "alt": ""
    }
  }), _vm._v("\n                        全场包邮\n                    ")])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0a6fd78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/goods/seckillList.vue
// module id = aq0g
// module chunks = 1